class RingEstimate extends HTMLElement {
    constructor() {
      super();
      this.url = this.dataset.url;
      this.countrySelect = this.querySelector('.js-country-selection');
      this.attachEvents();
      console.log(this.dataset);
      this.dataset.section.includes('product') && this.findCountry();
    }
  
    attachEvents(){
      this.querySelectorAll('.ring-price-select-item')?.forEach(button=>{
        button.addEventListener('click', e=>{
  
          button.closest('li').classList.add('active');
          button.closest('.cart-ring-estimate').classList.add('ring-selected');
        })
      })
  
      this.querySelector('.js-selection-back').addEventListener('click', e=>{
        this.querySelectorAll('li.active')?.forEach(i=>i.classList.remove('active'));
        e.target.closest('.cart-ring-estimate').classList.remove('ring-selected');
      })
  
      this.querySelector('.js-estimate-submit').addEventListener('click', e=>{
        e.target.closest('.cart-ring-estimate').classList.add('submited');
        this.fetchResult();
      })
  
      const countryInput = this.querySelector('.js-input-postcode');
      countryInput.addEventListener('keydown', e=>{
        if(e.keyCode != 13) return;
  
        e.preventDefault();
        e.stopPropagation();
  
        this.querySelector('.js-estimate-submit').dispatchEvent(new Event('click'));
  
      })
      this.countrySelect.addEventListener('change', e=>{
        countryInput.setAttribute('placeholder',  this.countrySelect.value == 'India' ? 'Enter zip' : ['Philippines', 'United States'].includes(this.countrySelect.value) ? 'Enter zip code' : 'Enter postal code' );
      })
  
    }
    fetchResult(){
      fetch(this.url + this.countrySelect.value + '&section_id=' + this.dataset.section).then(e=>e.text()).then(html=>{
        const div = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        console.log(div);
        this.querySelector('.js-estimate-result').innerHTML = div.innerHTML;
      })
    }
  
    findCountry(){
      var GEOURL = `https://get.geojs.io/v1/ip/geo.json`;
      fetch(GEOURL).then(e=>e.json()).then(e=>{
        e.city == "Melbourne" && this.classList.add("melbourne-city");
      })
    }
  }
  customElements.define('ring-estimate', RingEstimate);